export const MESSAGE_STANDARD_INFO = 'Hello, welcome to our Customer Service online chat. ' +
    'I would like to mention that the chat is monitored and recorded for quality assurance.';

export const MESSAGE_NO_AGENTS_AVAILABLE_DEFAULT = "We're very sorry, but all of our agents are assisting other patients right now. Please try again in a few minutes or visit <a href=\"https://covenanthealth.net/contact-us/\">Contact Us - Covenant Health</a> for additional options to service your account.\n"
export const QUEUE_NAME_CH = 'Covenant - CS';

export const QUEUE_TYPE_DEFAULT = 0;
